import _ from 'lodash';
import { useContext, useEffect } from 'react';
import { WrapperField } from '../../../../components/InputField/WrapperField';
import { shouldShowField, validateField } from '../../../../components/InputField/helper';
import { DialogContext } from '../../../../store/context/DialogContext';
import ButtonGroupNew from '../BusinessLiteForms/components/ButtonGroupNew';
import { FORM_TYPE, IPLUS_WIZARD } from '../IPlushelper';
import { useTranslation } from '../../../../store/context/TranslationContext';
import { Col, Row } from 'reactstrap';
import { getVisibleWizardFieldOrder } from '../components/IndividualLite/helper';

const IPlusDeclarationsForm = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    isForEDD,
    handleChange,
    handlePrev,
    formType
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    useEffect(() => {
        const initialErrors = {};
        iPlusFields.forEach((field) => {
            if (
                field.required &&
                field?.wizard === wizard &&
                shouldShowField(data, field.showIf)
            ) {
                const value = _.get(data, field.field);
                if (value === undefined || value === null || value === "") {
                    if (value !== false && !_.get(errors, field.field)) {
                        _.set(initialErrors, field.field, field.errorTypes?.required || field.error || "This field is required.");
                    }
                }
            }
        });

        const shownErrors = {};
        iPlusFields.forEach((field) => {
            if (field?.wizard === wizard && shouldShowField(data, field.showIf)) {
                const value = _.get(data, field.field);
                const error = validateField(field, value, data);
                if (error) {
                    _.set(shownErrors, field.field, error);
                }
            }
        });

        setErrors(_.merge({}, shownErrors, initialErrors));
    }, [data, wizard, iPlusFields]);

    const checkNext = () => {
        const orderedFields = getVisibleWizardFieldOrder({ fields: iPlusFields, wizard, data });
        for (const fieldPath of orderedFields) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                showError(fieldError);
                return false;
            }
        }
        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        if (data?.annualSalary > 2147483647) return showError("Currency should be less than 2147483647");

        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: { wizard: formType === FORM_TYPE.IndividualPrime ? IPLUS_WIZARD.IPlusOccupationDetails : IPLUS_WIZARD.IPlusAccountActivityDeclaration }, payload: data });
        } else {
            return;
        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    }

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            _.set(updatedErrors, field, errorMsg);
            return updatedErrors;
        })
    }

    return (
        <div className='row pt-1'>
            {/* <Col className='col-12 d-flex align-items-center justify-content-center'>
                <div className='text-center fw-medium fs-4 py-2 mb-4 fv__form-heading'>{t('Declarations')}</div>
            </Col> */}

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["hasBankAccount"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('hasBankAccount', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["hasCriminalRecord"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('hasCriminalRecord', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["criminalRecordDetail"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                className={'mb-2 px-1'}
                onError={(errorMsg) => handleErrors('criminalRecordDetail', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["isPoliticallyExposed"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('isPoliticallyExposed', errorMsg)}
                isForEDD={isForEDD}
            />

            <Row className='mb-2'>
                <Col className='col-12 col-md-6'>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["employmentStatus"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('employmentStatus', errorMsg)}
                        isForEDD={isForEDD}
                    />
                </Col>
                <Col className='col-12 col-md-6'>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["annualSalary"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('annualSalary', errorMsg)}
                        isForEDD={isForEDD}
                        customProp={'USD'}
                        customOperator={true}
                    />
                </Col>
            </Row>

            <Row className='mb-2'>
                <Col className='col-12 '>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["employmentIndustry"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('employmentIndustry', errorMsg)}
                        isForEDD={isForEDD}
                    />
                </Col>
            </Row>
            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["purposeOfAccount"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('purposeOfAccount', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["sourcesOfWealth"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('sourcesOfWealth', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["depositLocations"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('depositLocations', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["paymentLocations"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('paymentLocations', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["Interaction_With_South_American_Countries"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('Interaction_With_South_American_Countries', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["Interaction_With_Central_American_Countries"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('Interaction_With_Central_American_Countries', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["Interaction_With_Caribbean_Countries"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('Interaction_With_Caribbean_Countries', errorMsg)}
                isForEDD={isForEDD}
            />

            <WrapperField
                disabled={asLabel}
                jsonField={cyclosFields["interestedInCrypto"]}
                dataObj={data}
                onChange={handleUpdateFormData}
                showError={hasError}
                onError={(errorMsg) => handleErrors('paymentLocations', errorMsg)}
                isForEDD={isForEDD}
            />

            <div className='mt-4'>
                <ButtonGroupNew
                    onNextClick={handleSubmit}
                    onBackClick={() => { handlePrev() }}
                    step={2}
                    showPageNum={false}
                    pageNum={2}
                    hideSubmitButton={hideButtons}
                    asLabel={false}
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default IPlusDeclarationsForm;
